/**
 * Managed employees get a placeholder address generated by the backend
 * (`usuarioanonimo+<companyId>+<dni>@bilderit.com`, see
 * packages/backend/graphql/src/modules/user/domain/managed-user.ts).
 * Kept in its own tiny module so both apps can import it without pulling in
 * a screen.
 * Mirrors `isManagedUserEmail` in the backend and must stay identical.
 */
export const isManagedEmployeeEmail = (email: string) =>
  /^usuarioanonimo\+[^@]*@bilderit\.com$/i.test(email);
